import { graphql } from "gatsby"
import React from "react"
import Col from "react-bootstrap/Col"

import InlineLinkListItem from "@knowit-alma/common/src/components/atoms/InlineLinkListItem/InlineLinkListItem"
import Card from "@knowit-alma/common/src/components/molecules/Card/Card"
import CardGrid from "@knowit-alma/common/src/components/organisms/CardGrid/CardGrid"

const LogoGrid = ({ blockDataCardLogoGrid }) => {
  const { cards, showTextLink } = blockDataCardLogoGrid || {}

  const fullAreaIsLink = !showTextLink

  const items =
    cards?.length > 0
      ? cards.map((card, index) => {
          const { heading, logo, text, url } = card || {}

          const hostname = url
            ?.replace("http://", "")
            .replace("https://", "")
            .replace(/\/$/, "")
            .split("/")[0]

          return (
            <Col key={index} md="4">
              <Card
                fullAreaIsLink={fullAreaIsLink}
                internalLink={false}
                headingSize="h2"
                headingSmall
                image={logo}
                imageCentered={true}
                imageCenteredSmall={
                  logo?.mediaDetails?.width / logo?.mediaDetails?.height < 1.6
                }
                imageAspectRatio={"16:9"}
                title={heading}
                list={text
                  ?.split("\n")
                  .concat(
                    fullAreaIsLink ? (
                      []
                    ) : (
                      <InlineLinkListItem
                        key={url}
                        href={url}
                        text={hostname}
                        internal={false}
                        element="p"
                      />
                    )
                  )}
                url={url}
              />
            </Col>
          )
        })
      : null

  return <CardGrid items={items} />
}

export const query = graphql`
  fragment LogoGrid on WpBlockAcfCardLogoGrid {
    __typename
    blockDataCardLogoGrid {
      showTextLink
      cards {
        heading
        logo {
          mediaDetails {
            width
            height
          }
          sourceUrl
          altText
          altTextOriginal
        }
        text
        url
      }
    }
  }
`
export default LogoGrid
